import React, { useEffect } from 'react';
import AssessmentIcon from '@mui/icons-material/Assessment';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import ScienceIcon from '@mui/icons-material/Science';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import PageHeader from '../components/PageHeader';
import { trackFrontendEvent } from '../api/events';

export default function OnboardingEntryPage() {
  const navigate = useNavigate();
  useEffect(() => { void trackFrontendEvent('onboarding_started', { onboarding_step: 'entry' }); }, []);

  const choices = [
    {
      title: 'Online Boutique Benchmark',
      description:
        "Reproduce the published seven-case Playwright benchmark for Google's Online Boutique. Compare Full Suite, Random, History + Code Change, and Quantik Mind. Evaluate defect recall and runtime risk coverage.",
      icon: <AssessmentIcon fontSize="large" />,
      path: '/onboarding/benchmark',
    },
    {
      title: 'Create Your First Project',
      description:
        'Create a Quantik Mind project, then choose whether to explore with sample data or upload your own functional test data.',
      icon: <RocketLaunchIcon fontSize="large" />,
      path: '/onboarding/project',
    },
  ];

  return (
    <Box className="page-transition" sx={{ width: '100%', maxWidth: 1040, mx: 'auto' }}>
      <PageHeader
        icon={<ScienceIcon fontSize="inherit" />}
        title="Welcome to Quantik Mind"
        subtitle="Choose how you want to start."
      />

      <Paper
        elevation={3}
        sx={{
          borderRadius: 3,
          p: { xs: 2, md: 3 },
          background: 'linear-gradient(180deg, rgba(16, 20, 27, 0.98), rgba(10, 14, 20, 0.98))',
        }}
      >
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
          {choices.map((choice) => (
            <Card
              key={choice.title}
              className="enterprise-card"
              sx={{
                flex: 1,
                borderRadius: 3,
                borderColor: 'rgba(255,255,255,0.08)',
                transition: 'border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease',
                '&:hover, &:focus-within': {
                  borderColor: 'rgba(57,255,20,0.42)',
                  boxShadow: '0 0 0 1px rgba(57,255,20,0.18), 0 16px 34px rgba(57,255,20,0.14)',
                  transform: 'translateY(-2px)',
                },
              }}
            >
              <CardActionArea
                onClick={() => navigate(choice.path)}
                sx={{
                  height: '100%',
                  alignItems: 'stretch',
                  '&:focus-visible': {
                    outline: '2px solid #39FF14',
                    outlineOffset: -2,
                  },
                }}
              >
                <CardContent sx={{ p: { xs: 2.25, md: 3 }, height: '100%' }}>
                  <Stack spacing={2.5} sx={{ height: '100%' }}>
                    <Box sx={{ color: '#39FF14' }}>{choice.icon}</Box>
                    <Box>
                      <Typography variant="h6" fontWeight={700}>
                        {choice.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        {choice.description}
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Stack>
      </Paper>
    </Box>
  );
}
